/* eslint-disable react/prop-types */
import React from 'react';
import {
  ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip,
} from 'recharts';

/**
 * Single-series total monitor-sessions-per-day trend (028 US3), on the shared
 * au-panel design system (matches ActiveUsersTrendChart / PauseTrendChart). Coral
 * line, text-labelled legend, point tooltip, graceful single-day/empty handling.
 * NOT device-split (clarification 2026-07-10) — device breakdown lives in the cards.
 *
 * Props: { data } — [{ date:'YYYY-MM-DD', sessions:int }] ascending
 */
const shortDate = (d) => (d ? String(d).split('-').slice(1).reverse().join('/') : '');

const MonitorSessionTrendChart = ({ data = [] }) => {
  const enough = Array.isArray(data) && data.length >= 2;

  return (
    <div className="au-panel" data-testid="ms-trend">
      <div className="au-panel__head">
        <h4 className="au-panel__title">Monitor sessions per day</h4>
        <span className="au-spacer" />
        <div className="au-legend">
          <span><i style={{ background: '#f26b45' }} />Monitor sessions</span>
        </div>
      </div>

      {enough ? (
        <ResponsiveContainer width="100%" height={240}>
          <LineChart data={data} margin={{ top: 8, right: 12, left: 0, bottom: 4 }}>
            <CartesianGrid stroke="#eef2f1" vertical={false} />
            <XAxis dataKey="date" tickFormatter={shortDate} tick={{ fontSize: 11, fill: '#94a3b8' }} />
            <YAxis width={44} tick={{ fontSize: 11, fill: '#94a3b8' }} allowDecimals={false} />
            <Tooltip
              formatter={(value) => [Number(value).toLocaleString(), 'Monitor sessions']}
              labelFormatter={(l) => `Date: ${String(l).split('-').reverse().join('/')}`}
            />
            <Line type="monotone" dataKey="sessions" name="Monitor sessions" stroke="#f26b45" strokeWidth={2.5} dot={false} />
          </LineChart>
        </ResponsiveContainer>
      ) : (
        <div className="au-chart-empty" data-testid="ms-trend-empty">
          Not enough data to plot a trend (need at least 2 days).
        </div>
      )}
    </div>
  );
};

export default MonitorSessionTrendChart;
